import { BlogPost } from '@/types/blog';
import { content } from './content';
import betriebssystemImage from '@/assets/blog/betriebssystem-v5-2.webp';

export const betriebssystemPost: BlogPost = {
  title: 'Mein persönliches Betriebssystem v5.2: Ein Framework für Klarheit und Fokus',
  metaTitle: 'Persönliches Betriebssystem: Framework für Klarheit',
  subtitle: 'Wie ein Coach mit System denkt, entscheidet und handelt',
  date: '08.10.2025',
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: 'Coaching-Philosophie',
  tags: ['Selbstmanagement', 'Produktivität', 'Betriebssystem', 'Coaching', 'Entscheidungsfindung', 'Nachhaltigkeit', 'Künstliche Intelligenz', 'Framework'],
  excerpt: 'Ein Blick in den Maschinenraum: Wie ich mithilfe eines persönlichen "Betriebssystems" im täglichen Chaos aus Projekten und strategischen Zielen nicht nur überlebe, sondern bewusst gestalte. Keine magische Formel, sondern ein funktionierendes Framework – ständig im Dialog mit einem digitalen Sparringspartner entwickelt.',
  imageUrl: betriebssystemImage,
  content,
  slug: 'betriebssystem-v5-2',
  metaDescription: 'Persönliches Betriebssystem eines Coaches: Framework für bewusste Entscheidungen, Fokus und nachhaltigen Erfolg im Business-Alltag.',
};
